module.exports = __webpack_public_path__ + "img/HVS_HeavySword.cbb7f9cd.png";